export const formatCepString = (cepString: string) => {
    let cepList = cepString.replace(/\D/g,'')
    let cepNewString = ''
    let arrLoop = [...Array(8)]

    arrLoop.forEach((_, i) => {
        if (cepList[i]){
            cepNewString = `${cepNewString}${i === 5 ? '-': ''}${cepList[i]}`
        }
    });
    return cepNewString
}